import { supabase } from './supabase.js';
import { fetchReceivedReviews } from './reviewsService.js';

/**
 * Estadísticas públicas del vendedor (misma base que PagePerfilVendedor).
 * @param {string} sellerUserId
 */
export async function fetchSellerPublicStats(sellerUserId) {
  const id = String(sellerUserId ?? '').trim();
  if (!id) {
    return { ventas: 0, ratingAvg: null, ratingCount: 0, error: 'missing_seller' };
  }

  try {
    const [salesRes, revRes] = await Promise.all([
      supabase.from('transactions').select('id', { count: 'exact', head: true }).eq('seller_id', id),
      fetchReceivedReviews(id, { onlyVisible: true, limit: 300 }),
    ]);

    const revData = revRes.error ? [] : Array.isArray(revRes.data) ? revRes.data : [];
    const ratingCount = revData.length;
    const ratingAvg = ratingCount
      ? revData.reduce((s, r) => s + (Number(r.rating) || 0), 0) / ratingCount
      : null;

    return {
      ventas: salesRes.error ? 0 : Number(salesRes.count ?? 0),
      ratingAvg: ratingAvg != null ? Math.round(ratingAvg * 10) / 10 : null,
      ratingCount,
      error: null,
    };
  } catch (e) {
    console.error('[sellerPublicStatsService]', e);
    return { ventas: 0, ratingAvg: null, ratingCount: 0, error: 'fetch_failed' };
  }
}
